const texts = {
  en: {
    titleExisting: "Onboarding Form for Customers",
    companyNameLabel: "Company Name:",
    companyNameHover: "The registered name of your company or organization.",

    authorisedPersonLabel: "Authorised Person:",
    authorisedPersonHover:
      "The person authorized to make decisions on behalf of the company and sign POs and/or quotations in order to allow us to ship your order.",
    authorisedPersonEmailLabel: "Authorised Person Email:",
    authorisedPersonEmailHover: "Email address of the authorized person.",
    contactLabel: "General Lab Contact:",
    contactHover: "Contact to recieve deliveries for the lab.",
    emailLabel: "Email:",
    emailHover: "The email address used to recieve deliveries for the lab.",
    phoneLabel: "Phone:",
    phoneHover: "Contact phone number to recieve deliveries for the lab.",
    shippingAddressLabel: "Shipping Address:",
    shippingAddressHover: "Address where products will be delivered.",
    billingAddressLabel: "Billing Address:",
    billingAddressHover:
      "Address where invoices and financial correspondence will be sent.",
    vatTaxIdLabel: "VAT/Tax ID:",
    vatTaxIdHover:
      "Your company's VAT or Tax Identification Number for billing purposes.",
    invoicesSentToLabel: "Invoices Sent To:",
    invoicesSentToHover:
      "The email address where all invoices will be directed.",
    title: "Subscribe for product information",
    specialMessage: {
      offer: "✨Special offer✨",
      title: "Prepare your IVF lab for the year ahead",
      content: [
        {
          heading: "CryoLock Vit Straws",
          description: "Safe, efficient cryopreservation you can trust.",
        },
        {
          heading: "GEMS Vit & Warm Media",
          description: "Reliable media for consistent, superior results.",
        },
        {
          heading: "3. Validation Support",
          description:
            "Expert assistance to integrate and validate new protocols.",
        },
      ],
      closing: {
        title: "How to mitigate risk?",
        message:
          "❄️Diversify suppliers and stay ahead in 2025. Limited-time offer - Gems media and Cryolock Vitrification straws for validation*.❄️",
        cta: "📧 Contact us to find out more! ",
      },
    },
    nameLabel: "Full Name:",
    companyLabel: "Center, Clinic, Hospital:",
    telephoneLabel: "telephone (Optional):",
    inviaButton: "Send",
    productList: "Product Interest:",
    consentText:
      'By clicking "Send", I agree to the collection and processing of my personal data in accordance with Caring IVF\'s Privacy Policy. I also consent to receiving marketing communications from Caring IVF.',
    thankYouMessage:
      "Thank you! Your request has been received. You will be redirected shortly.",
    allProducts: "All Products",
    digitalCameras: "Digital Cameras",
    digitalCamerasHover:
      "Wifi cameras C-mount and invertion microscope compatible",
    cryokit: "Caring Genea Cryokit",
    carebot: "CareBot",
    cryokitHover: "Optimise pricing with a Gems+Cryolock bundle",
    carebotHover:
      "A versatile, plug-and-play lab robot designed for effortless installation and seamless integration into any workflow.",
    scryolock: "Lenshooke",
    scryolockHover: "Semen Quality Analyzer",
    cryolock: "Cryolock",
    cryolockHover: "Regular size",
    switchLanguage: "Switch to english",
    Timelapse: "Timelapse",
    witnessing: "Witnessing",
    media: "Media",
    witnessingHover: "Gidget",
    TimelapseHover: "Geri",
    mediaHover: "Gems",
    leica: "Leica",
    leicaHover: "Microscopie",
    titleExistingSpecial: "Sign up for the Caring IVF-Genea Cryokit",
    meeting: "or book a meeting by clinicing here",
  },
  it: {
    titleExisting: "Modulo di onboarding per clienti",
    companyNameLabel: "Nome della Società:",
    companyNameHover: "Il nome registrato della tua azienda o organizzazione.",

    authorisedPersonLabel: "Persona Autorizzata:",
    authorisedPersonHover:
      "La persona autorizzata a prendere decisioni per conto della società e a firmare PO e/o preventivi per consentirci di spedire il tuo ordine.",
    authorisedPersonEmailLabel: "Email della Persona Autorizzata:",
    authorisedPersonEmailHover: "Indirizzo email della persona autorizzata.",
    contactLabel: "Contatto generale del labo:",
    contactHover: "Contatto per ricevere le consegne per il laboratorio.",
    emailLabel: "Email:",
    emailHover:
      "L'indirizzo email utilizzato per ricevere le consegne per il laboratorio.",
    phoneLabel: "Telefono:",
    phoneHover:
      "Numero di telefono di contatto per ricevere le consegne per il laboratorio.",
    shippingAddressLabel: "Indirizzo di Spedizione:",
    shippingAddressHover: "Indirizzo dove verranno consegnati i prodotti.",
    billingAddressLabel: "Indirizzo di Fatturazione:",
    billingAddressHover:
      "Indirizzo dove verranno inviate le fatture e la corrispondenza finanziaria.",
    vatTaxIdLabel: "Partita IVA/ID Fiscale:",
    vatTaxIdHover:
      "La Partita IVA o il Numero di Identificazione Fiscale della tua azienda per scopi di fatturazione.",
    invoicesSentToLabel: "Fatture Inviate A:",
    invoicesSentToHover:
      "L'indirizzo email a cui verranno inviate tutte le fatture.",
    title: "Iscriviti per informazioni sui prodotti",
    specialMessage: {
      offer: "✨Offerta speciale✨",
      title: "Preparate il vostro laboratorio di FIV per il prossimo anno",
      content: [
        {
          heading: "Cannucce CryoLock Vit",
          description:
            "Crioconservazione sicura ed efficiente su cui potete contare.",
        },
        {
          heading: "Media GEMS Vit & Warm",
          description: "Media affidabili per risultati coerenti e superiori.",
        },
        {
          heading: "3. Supporto per la Validazione",
          description:
            "Assistenza esperta per integrare e validare nuovi protocolli.",
        },
      ],
      closing: {
        title: "Come mitigare il rischio?",
        message:
          "❄️Diversifica i fornitori e rimani avanti nel 2025. Offerta a tempo limitato - Mezzi Gems e cannucce Cryolock per vitrificazione per validazione*.❄️",
        cta: "📧 Contattaci per saperne di più!",
      },
    },

    nameLabel: "Nome Completo:",
    companyLabel: "Centro, Clinica, Ospedale:",
    telephoneLabel: "telefono (Opzionale):",
    inviaButton: "Invia",
    productList: "Interesse per i Prodotti:",
    consentText:
      "Cliccando su \"Invia\", accetto la raccolta e l'elaborazione dei miei dati personali in conformità con l'Informativa sulla privacy di Caring IVF. Acconsento inoltre a ricevere comunicazioni di marketing da Caring IVF.",
    thankYouMessage:
      "Grazie! La tua richiesta è stata ricevuta. Verrai reindirizzato a breve.",
    allProducts: "Tutti i Prodotti",
    digitalCameras: "Fotocamere Digitali",
    digitalCamerasHover:
      "Fotocamere Wifi compatibili con montatura C e microscopi a inversione",
    cryokit: "Caring Genea Cryokit",
    carebot: "CareBot",
    cryokitHover: "Ottimizza i prezzi con un bundle Gems+Cryolock",
    carebotHover:
      "A versatile, plug-and-play lab robot designed for effortless installation and seamless integration into any workflow.",
    scryolock: "Lenshooke",
    scryolockHover: "Dimensioni più ridotte",
    cryolock: "Cryolock",
    cryolockHover: "Dimensioni standard",
    switchLanguage: "Passa a Italiano",
    Timelapse: "Timelapse",
    witnessing: "Witnessing",
    media: "Media",
    witnessingHover: "Gidget",
    TimelapseHover: "Geri",
    mediaHover: "Gems",
    leica: "Leica",
    leicaHover: "Microscopie",
    titleExistingSpecial: "Iscriviti al Caring IVF-Genea Cryokit",
    meeting: "O prenota un incontro cliccando qui",
  },

  fr: {
    titleExisting: "Formulaire d'intégration pour les clients",
    companyNameLabel: "Nom de l'Entreprise:",
    companyNameHover: "Le nom enregistré de votre entreprise ou organisation.",

    authorisedPersonLabel: "Personne Autorisée:",
    authorisedPersonHover:
      "La personne autorisée à prendre des décisions au nom de l'entreprise et à signer des bons de commande et/ou des devis afin de nous permettre d'expédier votre commande.",
    authorisedPersonEmailLabel: "Email de la Personne Autorisée:",
    authorisedPersonEmailHover: "Adresse email de la personne autorisée.",
    contactLabel: "Contact général du lab:",
    contactHover: "Contact pour recevoir les livraisons pour le laboratoire.",
    emailLabel: "Email:",
    emailHover:
      "L'adresse email utilisée pour recevoir les livraisons pour le laboratoire.",
    phoneLabel: "Téléphone:",
    phoneHover:
      "Numéro de téléphone de contact pour recevoir les livraisons pour le laboratoire.",
    shippingAddressLabel: "Adresse de Livraison:",
    shippingAddressHover: "Adresse où les produits seront livrés.",
    billingAddressLabel: "Adresse de Facturation:",
    billingAddressHover:
      "Adresse où les factures et la correspondance financière seront envoyées.",
    vatTaxIdLabel: "TVA/ID Fiscal:",
    vatTaxIdHover:
      "Le numéro de TVA ou d'identification fiscale de votre entreprise à des fins de facturation.",
    invoicesSentToLabel: "Factures Envoyées À:",
    invoicesSentToHover:
      "L'adresse email à laquelle toutes les factures seront envoyées.",
    title: "Abonnez-vous pour recevoir des informations sur les produits",
    specialMessage: {
      offer: "✨Offre spéciale✨",
      title: "Préparez votre laboratoire de FIV pour l'année à venir",
      content: [
        {
          heading: "Pailles CryoLock Vit",
          description:
            "Une cryoconservation sûre et efficace sur laquelle vous pouvez compter.",
        },
        {
          heading: "Médias GEMS Vit & Warm",
          description:
            "Des médias fiables pour des résultats cohérents et supérieurs.",
        },
        {
          heading: "3. Support de Validation",
          description:
            "Assistance experte pour intégrer et valider de nouveaux protocoles.",
        },
      ],
      closing: {
        title: "Comment atténuer les risques ?",
        message:
          "❄️Diversifiez vos fournisseurs et prenez de l’avance en 2025. Offre limitée - Médias Gems et pailles Cryolock pour vitrification à des fins de validation*.❄️",
        cta: "📧 Contactez-nous pour en savoir plus !",
      },
    },

    nameLabel: "Nom Complet:",
    companyLabel: "Centre, Clinique, Hôpital:",
    telephoneLabel: "téléphone (Optionnel):",
    inviaButton: "Envoyer",
    productList: "Intérêt pour les Produits:",
    consentText:
      "En cliquant sur \"Envoyer\", j'accepte la collecte et le traitement de mes données personnelles conformément à la Politique de Confidentialité de Caring IVF. J'accepte également de recevoir des communications marketing de Caring IVF.",
    thankYouMessage:
      "Merci ! Votre demande a été reçue. Vous serez redirigé sous peu.",
    allProducts: "Tous les Produits",
    digitalCameras: "Appareils Photo Numériques",
    digitalCamerasHover:
      "Appareils photo Wifi compatibles avec monture C et microscope inversé",
    cryokit: "Caring Genea Cryokit",
    carebot: "CareBot",
    cryokitHover: "Optimisez les prix avec un bundle Gems+Cryolock",
    carebotHover:
      "Un robot de laboratoire polyvalent, prêt à l’emploi, conçu pour une installation facile et une intégration fluide dans tous les flux de travail.",
    scryolock: "Lenshooke",
    scryolockHover: "Taille plus fine",
    cryolock: "Cryolock",
    cryolockHover: "Taille standard",
    switchLanguage: "Passer en Français",
    Timelapse: "Timelapse",
    witnessing: "identitovigilence",
    media: "milieux de culture",
    witnessingHover: "Gidget",
    TimelapseHover: "Geri",
    mediaHover: "Gems",
    leica: "Leica",
    leicaHover: "Microscopie",
    titleExistingSpecial: "Inscrivez-vous au Caring IVF-Genea Cryokit",
    meeting: "Ou réservez une réunion en cliquant ici",
  },

  es: {
    titleExisting: "Formulario de incorporación para clientes",
    companyNameLabel: "Nombre de la Empresa:",
    companyNameHover: "El nombre registrado de su empresa u organización.",

    authorisedPersonLabel: "Persona Autorizada:",
    authorisedPersonHover:
      "La persona autorizada para tomar decisiones en nombre de la empresa y firmar PO y/o cotizaciones para que podamos enviar su pedido.",
    authorisedPersonEmailLabel: "Correo Electrónico de la Persona Autorizada:",
    authorisedPersonEmailHover:
      "Dirección de correo electrónico de la persona autorizada.",
    contactLabel: "Contacto general del lab:",
    contactHover: "Contacto para recibir entregas para el laboratorio.",
    emailLabel: "Correo Electrónico:",
    emailHover:
      "La dirección de correo electrónico utilizada para recibir entregas para el laboratorio.",
    phoneLabel: "Teléfono:",
    phoneHover:
      "Número de teléfono de contacto para recibir entregas para el laboratorio.",
    shippingAddressLabel: "Dirección de Envío:",
    shippingAddressHover: "Dirección donde se entregarán los productos.",
    billingAddressLabel: "Dirección de Facturación:",
    billingAddressHover:
      "Dirección donde se enviarán las facturas y la correspondencia financiera.",
    vatTaxIdLabel: "NIF/ID Fiscal:",
    vatTaxIdHover:
      "El NIF o Número de Identificación Fiscal de su empresa para fines de facturación.",
    invoicesSentToLabel: "Facturas Enviadas A:",
    invoicesSentToHover:
      "La dirección de correo electrónico a la que se enviarán todas las facturas.",
    title: "Suscríbase para recibir información del producto",
    specialMessage: {
      offer: "✨Oferta especial✨",
      title: "Prepare su laboratorio de FIV para el próximo año",
      content: [
        {
          heading: "Pajuelas CryoLock Vit",
          description:
            "Criopreservación segura y eficiente en la que puede confiar.",
        },
        {
          heading: "Medios GEMS Vit & Warm",
          description:
            "Medios fiables para resultados consistentes y superiores.",
        },
        {
          heading: "3. Soporte de Validación",
          description:
            "Asistencia experta para integrar y validar nuevos protocolos.",
        },
      ],
      closing: {
        title: "¿Cómo mitigar el riesgo?",
        message:
          "❄️Diversifica tus proveedores y mantente a la vanguardia en 2025. Oferta por tiempo limitado - Medios Gems y pajillas Cryolock para vitrificación para validación*. ❄️",
        cta: "📧 ¡Contáctanos para saber más!",
      },
    },

    nameLabel: "Nombre Completo:",
    companyLabel: "Centro, Clínica, Hospital:",
    telephoneLabel: "teléfono (Opcional):",
    inviaButton: "Enviar",
    productList: "Interés en el Producto:",
    consentText:
      'Al hacer clic en "Enviar", acepto la recopilación y el procesamiento de mis datos personales de acuerdo con la Política de privacidad de Caring IVF. También acepto recibir comunicaciones de marketing de Caring IVF.',
    thankYouMessage:
      "¡Gracias! Su solicitud ha sido recibida. Será redirigido en breve.",
    allProducts: "Todos los Productos",
    digitalCameras: "Cámaras Digitales",
    digitalCamerasHover:
      "Cámaras Wifi compatibles con montura C y microscopios de inversión",
    cryokit: "Caring Genea Cryokit",
    carebot: "CareBot",
    cryokitHover: "Optimiza precios con un paquete Gems+Cryolock",
    carebotHover:
      "A versatile, plug-and-play lab robot designed for effortless installation and seamless integration into any workflow.",
    scryolock: "Lenshooke",
    scryolockHover: "Tamaño más pequeño",
    cryolock: "Cryolock",
    cryolockHover: "Tamaño estándar",
    switchLanguage: "Cambiar a Español",
    Timelapse: "Timelapse",
    witnessing: "Witnessing",
    media: "Media",
    witnessingHover: "Gidget",
    TimelapseHover: "Geri",
    mediaHover: "Gems",
    leica: "Leica",
    leicaHover: "Microscopie",
    titleExistingSpecial: "Regístrate en el Caring IVF-Genea Cryokit",
    meeting: "O reserva una reunión haciendo clic aquí",
  },

  pt: {
    titleExisting: "Formulário de integração para clientes",
    companyNameLabel: "Nome da Empresa:",
    companyNameHover: "O nome registrado da sua empresa ou organização.",

    authorisedPersonLabel: "Pessoa Autorizada:",
    authorisedPersonHover:
      "A pessoa autorizada a tomar decisões em nome da empresa e a assinar PO e/ou cotações para permitir que enviemos seu pedido.",
    authorisedPersonEmailLabel: "Email da Pessoa Autorizada:",
    authorisedPersonEmailHover: "Endereço de email da pessoa autorizada.",
    contactLabel: "Contato geral do lab:",
    contactHover: "Contato para receber entregas para o laboratório.",
    emailLabel: "Email:",
    emailHover:
      "O endereço de email utilizado para receber entregas para o laboratório.",
    phoneLabel: "Telefone:",
    phoneHover:
      "Número de telefone de contato para receber entregas para o laboratório.",
    shippingAddressLabel: "Endereço de Entrega:",
    shippingAddressHover: "Endereço onde os produtos serão entregues.",
    billingAddressLabel: "Endereço de Faturamento:",
    billingAddressHover:
      "Endereço para onde serão enviadas as faturas e a correspondência financeira.",
    vatTaxIdLabel: "CIF/ID Fiscal:",
    vatTaxIdHover:
      "O CIF ou Número de Identificação Fiscal da sua empresa para fins de faturamento.",
    invoicesSentToLabel: "Faturas Enviadas Para:",
    invoicesSentToHover:
      "O endereço de email para onde todas as faturas serão direcionadas.",
    title: "Inscreva-se para informações sobre produtos",
    specialMessage: {
      offer: "✨Oferta especial✨",
      title: "Prepare seu laboratório de FIV para o próximo ano",
      content: [
        {
          heading: "Canudos CryoLock Vit",
          description:
            "Criopreservação segura e eficiente em que você pode confiar.",
        },
        {
          heading: "Meios GEMS Vit & Warm",
          description:
            "Meios confiáveis para resultados consistentes e superiores.",
        },
        {
          heading: "3. Suporte à Validação",
          description:
            "Assistência especializada para integrar e validar novos protocolos.",
        },
      ],
      closing: {
        title: "Como mitigar riscos?",
        message:
          "❄️Diversifique seus fornecedores e esteja à frente em 2025. Oferta por tempo limitado - Meios Gems e palhetas Cryolock para vitrificação para validação*.❄️",
        cta: "📧 Entre em contato para saber mais!",
      },
    },
    nameLabel: "Nome Completo:",
    companyLabel: "Centro, Clínica, Hospital:",
    telephoneLabel: "telefone (Opcional):",
    inviaButton: "Enviar",
    productList: "Interesse em Produtos:",
    consentText:
      'Ao clicar em "Enviar", concordo com a coleta e o processamento dos meus dados pessoais de acordo com a Política de Privacidade da Caring IVF. Também aceito receber comunicações de marketing da Caring IVF.',
    thankYouMessage:
      "Obrigado! Sua solicitação foi recebida. Você será redirecionado em breve.",
    allProducts: "Todos os Produtos",
    digitalCameras: "Câmeras Digitais",
    digitalCamerasHover:
      "Câmeras Wifi compatíveis com montagem C e microscópios de inversão",
    cryokit: "Caring Genea Cryokit",
    carebot: "CareBot",
    cryokitHover: "Otimize os preços com um pacote Gems+Cryolock",
    carebotHover:
      "A versatile, plug-and-play lab robot designed for effortless installation and seamless integration into any workflow.",
    scryolock: "Lenshooke",
    scryolockHover: "Tamanho menor",
    cryolock: "Cryolock",
    cryolockHover: "Tamanho padrão",
    switchLanguage: "Mudar para Português",
    Timelapse: "Timelapse",
    witnessing: "Witnessing",
    media: "Media",
    witnessingHover: "Gidget",
    TimelapseHover: "Geri",
    mediaHover: "Gems",
    leica: "Leica",
    leicaHover: "Microscopie",
    titleExistingSpecial: "Inscreva-se no Caring IVF-Genea Cryokit",
    meeting: "Ou agende uma reunião clicando aqui",
  },
};
export default texts;
